import React from "react";
import { ProgressBar } from "react-bootstrap";
import { formatBytes } from "../utils/formatters";
import styles from "../styles.module.css";

const PRODUCT_META = {
  gemeo_digital: { icon: "fa-cube",        label: "Gêmeo Digital", color: "#035184" },
  tour_360:      { icon: "fa-street-view", label: "Tour 360°",     color: "#1067b9" },
  filmagens:     { icon: "fa-video",       label: "Filmagens",     color: "#2d6d82" },
  fotos:         { icon: "fa-camera",      label: "Fotos",         color: "#39474b" },
  geoview:       { icon: "fa-map",         label: "GeoView",   color: "#0d9488" },
  ortomosaico:  { icon: "fa-map",         label: "GeoView",   color: "#0d9488" }, // legado
  geotiff:       { icon: "fa-map",         label: "GeoView",   color: "#0d9488" }, // alias legado
};

const ProjectSummary = ({
  usedStorageInBytes,
  maxStorageInBytes,
  currentProjects,
  maxProjects,
  isLoading,
  existingProjects = [],
  onSelectProject
}) => {
  const storagePct  = maxStorageInBytes > 0 ? (usedStorageInBytes / maxStorageInBytes) * 100 : 0;
  const projectsPct = maxProjects > 0 ? (currentProjects / maxProjects) * 100 : 0;

  const getBarVariant = pct => {
    if (pct <= 50) return "success";
    if (pct <= 75) return "warning";
    return "danger";
  };

  return (
    <div className={styles.summaryCard}>
      {/* Resumo do plano */}
      <p className={styles.summaryTitle}>Resumo do plano</p>

      {isLoading ? (
        <p style={{ fontSize: "0.82rem", color: "#94a3b8", textAlign: "center", padding: "0.5rem 0" }}>
          Carregando...
        </p>
      ) : (
        <>
          <div className={styles.summaryRow}>
            <span>Armazenamento</span>
            <span className={styles.summaryValue}>
              {formatBytes(usedStorageInBytes)} / {formatBytes(maxStorageInBytes)}
            </span>
          </div>
          <ProgressBar
            now={storagePct}
            variant={getBarVariant(storagePct)}
            className={styles.storageBar}
            style={{ height: 5 }}
          />

          <div className={styles.summaryRow}>
            <span>Projetos</span>
            <span className={styles.summaryValue}>{currentProjects} / {maxProjects || "∞"}</span>
          </div>
          {maxProjects > 0 && (
            <ProgressBar
              now={projectsPct}
              variant={getBarVariant(projectsPct)}
              className={styles.storageBar}
              style={{ height: 5 }}
            />
          )}
        </>
      )}

      {/* Projetos existentes */}
      {existingProjects.length > 0 && (
        <div className={styles.existingSection}>
          <p className={styles.summaryTitle}>Projetos existentes</p>
          <ul className={styles.existingList}>
            {existingProjects.slice(0, 12).map((project, idx) => {
              const products = project.dates?.flatMap(d => d.products || []) || [];
              const mainProduct = products[0];
              const meta = PRODUCT_META[mainProduct] || { icon: "fa-folder", color: "#64748b" };
              return (
                <li
                  key={idx}
                  className={styles.existingItem}
                  onClick={() => onSelectProject?.(project.name)}
                  title={`Adicionar upload ao projeto "${project.name}"`}
                >
                  {project.thumbnail ? (
                    <img
                      src={project.thumbnail}
                      alt={project.name}
                      className={styles.existingItemThumb}
                    />
                  ) : (
                    <div className={styles.existingItemIcon} style={{ background: meta.color + "18", color: meta.color }}>
                      <i className={`fas ${meta.icon}`} />
                    </div>
                  )}
                  <div className={styles.existingItemInfo}>
                    <div className={styles.existingItemName}>{project.name}</div>
                    <div className={styles.existingItemMeta}>
                      {project.last_date || "—"} · {products.length} produto(s)
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
          {existingProjects.length > 12 && (
            <p className={styles.emptyProjects}>+{existingProjects.length - 12} projetos</p>
          )}
        </div>
      )}

      {!isLoading && existingProjects.length === 0 && (
        <div className={styles.existingSection}>
          <p className={styles.summaryTitle}>Projetos existentes</p>
          <p className={styles.emptyProjects}>Nenhum projeto encontrado</p>
        </div>
      )}
    </div>
  );
};

export default ProjectSummary;
